module.exports = __webpack_public_path__ + "static/img/4.dff93d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1/4.gif
// module id = hgNK
// module chunks = 1